import React from 'react';
import { ButtonV2 } from '@zola/zola-ui';

import './BlankState.less';

const BlankState = () => {
  const handleAddRegistryOnClick = () => {
    window.location.href = '/wedding-registry/add-other-registry';
  };

  return (
    <div className="other-registries__blank-state__container">
      <div className="other-registries__blank-state__body">
        <p className="other-registries__blank-state__dek">Want to add a registry from another store to your Zola registry?</p>
        <ButtonV2 className="other-registries__blank-state__button" onClick={handleAddRegistryOnClick}>Add A Registry</ButtonV2>
      </div>
    </div>
  );
};

export default BlankState;



// WEBPACK FOOTER //
// ./src/components/settings/registry/OtherRegistries/BlankState.jsx